export const GLOBALS = {
  TESTING: false,
  BUILD_ENV: "staging",
  NAME: "Files",
  URL: "https://files.cinesendstaging.com",
  API_URL: "https://api.cinesendstaging.com/api",
  FILES_URL: "https://files.cinesendstaging.com",
  ACCOUNTS_URL: "https://accounts.cinesendstaging.com",
  PUSHER_KEY: "0edd289b7933fc036740",
  PUSHER_DEBUG: false,
  AWS_ACCELERATED_ENDPOINT: "https://cinesendcontainer-beta.s3-accelerate.amazonaws.com"
}
